import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import classes from "./TimelineBlock.module.css";
import locationIcon from "../../../../../assets/header/Exclude.png";
import moment from "moment";
import Icon from "../../../../ui/icons/Icon";
import ItemBlock from '../../itemBlock/ItemBlock';

const monthKeyFromDate = (date) =>
    moment(date).locale("en").format("MMMM").toLowerCase();

const TimelineBlock = ({ stages = [], title, logo }) => {

    const { texts, lang } = useSelector(state => state.translate);
    const [selectedName, setSelectedName] = useState(null);

    useEffect(() => {
        if (!stages?.length) return;

        const current = stages.find((s) => s.isCurrent);
        const currentName = current?.name;

        setSelectedName((prev) => (prev == null ? currentName : prev));
    }, [stages]);

    const selectedStage = stages.find((s) => s.name === selectedName);

    const getMonthName = (date) => {
        const monthKey = monthKeyFromDate(date);
        return texts?.[monthKey] ?? monthKey;
    };

    const getDay = (date) => moment(date).format("D");

    const getStageDateLabel = (stage) => {
        if (stage?.finalRejected) {
            return texts.finalRejectedBigText;
        }
        const startDay = getDay(stage.startDate);
        const endDay = getDay(stage.endDate);
        const monthName = getMonthName(stage.startDate);
        if (startDay == endDay || stage?.hiddenToDate) {
            return `${startDay} ${monthName}`;
        }

        return `${startDay}-${endDay} ${monthName}`;
    };

    const getHebrewDate = (stage) => {
        if (!stage?.hebrewDateKey) return null;
        return texts?.[stage.hebrewDateKey] ?? null;
    };

    if (!stages.length || !selectedStage) return null;

    // בדיקה אם השלב הנבחר הוא לפני או שווה לשלב הנוכחי
    const currentIndex = stages.findIndex((s) => s.isCurrent);
    const selectedIndex = stages.findIndex((s) => s.name === selectedName);
    const shouldShowLocation = currentIndex !== -1 && selectedIndex !== -1 && selectedIndex <= currentIndex;

    return (
        <ItemBlock title={texts[title] || title} icon={<img src={logo.src[lang]} alt={logo.alt} />}   >
            <div className={classes.wrapper} dir="rtl">
                <div className={classes.detailsContainer}>
                    <div className={classes.fixedRange}>{texts?.fixedTimelineRange}</div>

                    <div className={classes.detailsCard}>
                        <div className={classes.detailsHeader}>
                            {shouldShowLocation && (
                                <img
                                    src={locationIcon}
                                    alt="Location"
                                    className={classes.locationIcon}
                                />
                            )}
                            {selectedStage.icon && (
                                <Icon
                                    name={selectedStage.icon}
                                    size="20px"
                                />
                            )}
                            <div className={classes.detailsTitle}>
                                {selectedStage?.nameKey ? texts?.[selectedStage.nameKey] : ''}
                            </div>
                        </div>

                        <div className={classes.detailsText}>
                            {selectedStage.descriptionKey && texts[selectedStage.descriptionKey]}
                        </div>
                    </div>
                </div>

                <div className={classes.timeline}>
                    <div className={classes.steps}>
                        {stages.map((stage, idx) => {
                            const isSelected = stage.name === selectedName;
                            const currentIndex = stages.findIndex((s) => s.isCurrent);
                            const isCompleted = currentIndex !== -1 && idx <= currentIndex;

                            return (
                                <button
                                    key={stage.name}
                                    type="button"
                                    className={[
                                        classes.step,
                                        isSelected ? classes.selected : "",
                                        isCompleted ? classes.completed : classes.upcoming,
                                    ].join(" ")}
                                    onClick={() => setSelectedName(stage.name)}
                                >
                                    <div className={classes.dateContainer}>
                                        <div className={classes.date}>{getStageDateLabel(stage)}</div>
                                        {getHebrewDate(stage) && (
                                            <div className={classes.hebrewDate}>{getHebrewDate(stage)}</div>
                                        )}
                                    </div>

                                    <div className={classes.iconWrap}>
                                        {typeof stage.icon === "string" ? (
                                            <Icon
                                                name={stage.icon}
                                                size="20px"
                                            />
                                        ) : (
                                            stage.icon
                                        )}
                                        {idx !== stages.length - 1 && (
                                            <div className={classes.dots} />
                                        )}
                                    </div>
                                    <div className={classes.name}>{stage?.nameKey ? texts?.[stage.nameKey] : ''}</div>
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>
        </ItemBlock>
    );
};

export default TimelineBlock;
